var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUUsersAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 16,
    fill: "url(#paint0_linear_482_3746)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 27V25C28 23.1362 26.7252 21.5701 25 21.126M21.5 9.29076C22.9659 9.88415 24 11.3213 24 13C24 14.6787 22.9659 16.1159 21.5 16.7092M23 27C23 25.1362 23 24.2044 22.6955 23.4693C22.2895 22.4892 21.5108 21.7105 20.5307 21.3045C19.7956 21 18.8638 21 17 21H14C12.1362 21 11.2044 21 10.4693 21.3045C9.48915 21.7105 8.71046 22.4892 8.30448 23.4693C8 24.2044 8 25.1362 8 27M19.5 13C19.5 15.2091 17.7091 17 15.5 17C13.2909 17 11.5 15.2091 11.5 13C11.5 10.7909 13.2909 9 15.5 9C17.7091 9 19.5 10.7909 19.5 13Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_482_3746",
    x1: 18,
    y1: -0.00000107288,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#008500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#008500"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUUsersAlt);
export default __webpack_public_path__ + "static/media/u_users-alt.53b66df7493dfee8dfea4917305195f3.svg";
export { ForwardRef as ReactComponent };